import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './TarjetasEducativas.css';
import axios from "axios";

import CardETFsEducational from "../../components/ui/card/CardETFsEducational";

const dominio = process.env.REACT_APP_DOMINIO;

function TarjetasEducativas(props) {

  let [contenidoEducativo, setContenidoEducativo] = useState([]);

  useEffect(() => {
    let urlContenidoEducativo = `${dominio}/cms/o/documents/etf-educativo/lang/${props.lang}`;

    axios.get(urlContenidoEducativo)
      .then(response => {
        setContenidoEducativo(response.data);
      })
      .catch(err => console.error("Error al obtener el contenido de la sección de nuevos listados. " + err.message));
  }, []);

  return (
    <div className="row" >
      {contenidoEducativo.map((tarjeta, index) => (
        <div key={"ETFEduca_" + index} className={[css.fondo, "margin_bottom_10 col-lg-3 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
          <CardETFsEducational title={tarjeta.titulo} body={tarjeta.resumen} src={tarjeta.documento} />
        </div>
      ))}
    </div>
  );
}

TarjetasEducativas.propTypes = {
    lang: PropTypes.string
}

export default memo(TarjetasEducativas);
